import {
  TCompensationAttribution,
  TCompensationSpendingBreakdown,
  TCompensationSummary,
  TMenhirCompensationAttribution,
  TMenhirCompensationSpendingBreakdown,
  TMenhirCompensationSummary,
} from '@/common/integrations/menhir/employee/compensation/compensation.types';

export const transformCompensationSummary = (
  summary: TMenhirCompensationSummary
): TCompensationSummary => ({
  status: summary.status,
  renewalDate: summary.renewal_date,
  attributions: Array.isArray(summary.attributions) ? summary.attributions.map(transformCompensationAttribution) : [],
  benefits: Array.isArray(summary.benefits) ? summary.benefits : [],
});

export const transformCompensationAttribution = (
  attribution: TMenhirCompensationAttribution
): TCompensationAttribution => ({
  id: attribution.id,
  slug: attribution.slug,
  balance: attribution.balance,
  spendingTotal: attribution.spending_total,
});

export const transformCompensationSpendingBreakdown = (
  breakdown: TMenhirCompensationSpendingBreakdown
): TCompensationSpendingBreakdown => ({
  total: breakdown.total,
  accumulated: breakdown.accumulated,
  attributions: Array.isArray(breakdown.attributions) ? breakdown.attributions.map(transformCompensationAttribution) : [],
});
